module.exports = __webpack_public_path__ + "img/Monte_Kope_29.934cbdf8.jpg";